import webAPIHelper from "../common/utils/webAPIHelper";

const controller = "/CategoriasProductos";

let cachedCategories = null;

export default async function CategoriasProductos() {
  if (cachedCategories) return cachedCategories;
  const appsvc = new webAPIHelper();
  cachedCategories = await appsvc.Get(controller);
  return cachedCategories;
}

export async function CategoriaProducto(nombreCategoria) {
  const allCategories = await CategoriasProductos();
  if (!allCategories) return null;
  return allCategories.find(c => c.nombre === nombreCategoria);
}
